import React from 'react';
import { PrivateBankingServiceDefinitionId } from 'pco-product-service-internal-consumer';
import type { ConfigureProductGroupModalProps } from './groups/configureProductGroupModalProps';
import { ActiveReferralRmModal } from './groups/activeReferralRm/ActiveReferralRmModal';
import { ExternalServicingUsersModal } from './groups/externalServicingUsers/ExternalServicingUsersModal';
import { PartnerServiceRoleModal } from './groups/partnerServiceRole/PartnerServiceRoleModal';
import { SafeDepositBoxModal } from './groups/safeDepositBox/SafeDepositBoxModal';
import { SimpleProductModal } from './groups/simple/SimpleProductModal';

const groupModalByServiceDefinitionId: Partial<
  Record<PrivateBankingServiceDefinitionId, React.FC<ConfigureProductGroupModalProps>>
> = {
  [PrivateBankingServiceDefinitionId.Ebanking]: PartnerServiceRoleModal,
  [PrivateBankingServiceDefinitionId.DebitMaestrocard]: PartnerServiceRoleModal,
  [PrivateBankingServiceDefinitionId.SafeDepositBox]: SafeDepositBoxModal,
  [PrivateBankingServiceDefinitionId.WealthPlanningServices]: ExternalServicingUsersModal,
  [PrivateBankingServiceDefinitionId.ActiveReferralWp]: ExternalServicingUsersModal,
  [PrivateBankingServiceDefinitionId.ActiveReferralRm]: ActiveReferralRmModal,
};

export const getConfigureProductGroupModal = (serviceDefinitionId?: PrivateBankingServiceDefinitionId) =>
  (serviceDefinitionId && groupModalByServiceDefinitionId[serviceDefinitionId]) || SimpleProductModal;
